import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  row: {
    padding: "14px",
    display: "grid",
    gridTemplateColumns: "16px 1fr 20px",
    backgroundColor: theme.palette.primary.contrastText,
    alignItems: "center"
  },
  marker: {
    display: "flex",
    marginTop: "8px",
    alignSelf: "flex-start"
  },
  activityInfo: {
    display: "flex",
    flexDirection: "column",
    marginRight: "8px"
  },
  activityInfoName: {
    fontSize: 14,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    cursor: "pointer"
  },
  activityInfoContent: {
    fontSize: 12,
    fontFamily: "SuisseIntlRegular"
  },
  button: {
    height: "24px",
    width: "24px",
    padding: 0,
    color: theme.palette.common.black
  },
  buttonIconOpen: {
    margin: "4px 0 0 4px"
  }
}));
